import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../css/Page.module.css";
import data from "../Data";
import anfenerImg from "../assets/images/talent/Anfener.jpg";
import markImg from "../assets/images/talent/mark.jpg";
import srujithImg from "../assets/images/talent/srujith.png";
import talamImg from "../assets/images/talent/talam.jpg";

function Talent() {
  const talentImages = {
    ANFENER: anfenerImg,
    MARK: markImg,
    SRUJITH: srujithImg,
    TALAM: talamImg,
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <h1 className={styles.title}>Talent</h1>
        <p className={styles.text}>
          Discover our talented roster of artists, performers, and creative professionals who bring events to life.
        </p>
        <div className={styles.talentList}>
          {data.TalentList.map((artist, index) => (
            <div key={index} className={styles.talentItem}>
              {talentImages[artist] && (
                <div className={styles.talentImageWrapper}>
                  <img
                    src={talentImages[artist]}
                    alt={`${artist}`}
                    className={styles.talentPhoto}
                  />
                </div>
              )}
              <h2 className={styles.talentName}>{artist}</h2>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Talent;

